import { render, staticRenderFns } from "./SurveyBeginStart.vue?vue&type=template&id=2146a582&scoped=true&"
import script from "./SurveyBeginStart.vue?vue&type=script&lang=js&"
export * from "./SurveyBeginStart.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBeginStart.vue?vue&type=style&index=0&id=2146a582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146a582",
  null
  
)

export default component.exports